import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import server from "api/server";
import { useLocation } from "react-router-dom";
import { getPageSection } from "api/pages";
import imageUpload from "../../../assets/svgs/imageUpload.svg";
import toast from "react-hot-toast";
import fileIcon from "../../../assets/images/file.png";
import ImageUpdate from "components/shared/ImageUpdate";

const Index = () => {
  const { pathname } = useLocation();
  const slug = pathname.split("/")[2];

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [data, setData] = useState([]);
  const [providerImg, setProviderImg] = useState({
    preview: null,
    path: null,
  });
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgress, setShowProgress] = useState(false);
  const [sectionBg, setSectionBg] = useState({
    preview: null,
    path: null,
  });

  const onStart = async () => {
    const pageData = await getPageSection("home", slug);
    setData(pageData);
  };

  useEffect(() => {
    onStart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    reset({
      sectionTitle: data?.sectionTitle,
    });

    if (data?.file) {
      // Set the uploaded file as preview
      setProviderImg({
        preview: data?.file,
        path: data?.file,
      });
    }

    if (data?.sectionBg) {
      // Set the uploaded file as preview
      setSectionBg({
        preview: data?.sectionBg,
        path: data?.sectionBg,
      });
    }
  }, [reset, data]);

  const providersImageChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setShowProgress(true); // Show progress bar when upload starts
      const myFormData = new FormData();
      myFormData.append("file", e.target.files[0]);

      const config = {
        onUploadProgress: (progressEvent) => {
          // Calculate the upload percentage
          const progress = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          // Update the upload progress state
          setUploadProgress(progress);
        },
      };

      try {
        const { data } = await server().post("/uploads", myFormData, config);

        setProviderImg({
          preview: e.target.files[0],
          path: data.data.files[0].fullpath,
        });
      } catch (error) {
        console.error("Upload failed:", error);
        setShowProgress(false);
      }
    }
  };

  const removeProviderImg = () => {
    setProviderImg();
  };

  const onSubmit = async (data) => {
    try {
      data.file = providerImg.path;
      data.title = slug;
      data.sectionBg = sectionBg.path;

      // eslint-disable-next-line no-unused-vars
      const savedResponse = await server().put(`/pages/home/sections/${slug}`, {
        section: data,
      });

      toast.success("تم حفظ التغيرات", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    } catch (error) {
      toast.error("يوجد خطأ فى حفظ البيانات ", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  };

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>محتوي بروفايل الشركة</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xxl={8} lg={12} md={12}>
                <Row>
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5>ملف الهوية</h5>
                      <div className="video-uploader">
                        <div className="image-uploader image-contain">
                          <div className="img-pat">
                            <img
                              src={imageUpload}
                              width={46}
                              height={46}
                              alt=""
                            />
                          </div>
                          <label>
                            {providerImg && (
                              <div>
                                <img
                                  src={fileIcon}
                                  width={160}
                                  height={160}
                                  alt=""
                                  style={{
                                    padding: "20px",
                                  }}
                                />
                                <button
                                  className="removeImg"
                                  onClick={removeProviderImg}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-x-lg"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
                                    />
                                  </svg>
                                </button>
                              </div>
                            )}
                            <input
                              accept="document/*"
                              type="file"
                              onChange={providersImageChange}
                            />
                          </label>
                        </div>
                        {showProgress && (
                          <div className="upload-progress">
                            <div className="progress">
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{ width: `${uploadProgress}%` }}
                                aria-valuenow={uploadProgress}
                                aria-valuemin={0}
                                aria-valuemax={100}
                              ></div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col lg={12} xs={12}>
                    <div className="form-group">
                      <h5>عنوان</h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="عنوان"
                          {...register("sectionTitle")}
                        />
                      </div>
                      {errors?.sectionTitle && (
                        <p className="error-hint">يرجي ادخال العنوان</p>
                      )}
                    </div>
                  </Col>
                  <Col lg={12} className="card-settings">
                    <div className="form-group required upload-cover">
                      <h5>صورة الخلفية</h5>
                      <ImageUpdate
                        selectedImage={sectionBg}
                        setSelectedImage={setSectionBg}
                      />
                    </div>
                  </Col>

                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        حفظ
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
